<template>
  <div class="mallItemPerson" :style="boxStyle">
    <div class="mallTitle" v-if="pattern.showTitle||pattern.showMore">
      <p class="title" v-if="pattern.showTitle">{{ content.titleText }}</p>
      <p class="moreText" v-if="pattern.showMore">{{ content.moreText }}</p>
    </div>
    <div>
      <div v-show="detailData.goodsList.length" v-for="(item,i) in detailData.goodsList" :key="i" :class="allShowVerFlag?'p-item':(isClass?'p-item_v isClass':'p-item_v')">
        <div class="item_logo nophoto">
          <div class="tqj_l m_label0" v-show="allShowVerFlag&&(item.privilegePrice||item.privilegePrice===0)">{{item.divPrivilegePrice}} 特权价</div>
          <div class="logo_tag" v-if="item.tagImages">
            <img mode="aspectFit"  :src="item.tagImages" />
          </div>
          <img :src="item.showImg" />
        </div>
        <div class="pname" v-show="allShowVerFlag">{{item.name}}</div>
        <div class="pinfo" v-show="allShowVerFlag">
          <div class="l_box">
            <div class="price m_label1" :class="{'score_money':(item.creditExchange || item.onlineCreditExchange)}">
              {{ (item.creditExchange || item.onlineCreditExchange) ?
              (item.creditExchange || item.onlineCreditExchange) + (item.creditExchange ? '门店积分' : '线上积分') + (item.price ? ('+￥' + item.price) : '') :
              item.newCustPrice && localInviteId && isNewMember ? item.newCustPrice : item.price }}
              <text class="price_old m_label0" v-if="showOriginalPrice">{{item.originalprice}}</text>
            </div>
          </div>
          <div class="buyBtn" v-if="pattern.showBuyBtn">
            <i class="s-iconfont shair-gouwuche"></i>
          </div>
        </div>
        <div class="r_box" v-show="!allShowVerFlag">
          <div class="pname">{{item.name}}</div>
          <div class="lit_title">{{item.quickDescription || ""}}</div>
          <div class="label">
            <div class="tag-warp">

            </div>
          </div>
          <div class="price m_label1" :class="{'score_money':(item.creditExchange || item.onlineCreditExchange)}">
              {{ (item.creditExchange || item.onlineCreditExchange) ?
              (item.creditExchange || item.onlineCreditExchange) + (item.creditExchange ? '门店积分' : '线上积分') + (item.price ? ('+￥' + item.price) : '') :
              item.newCustPrice && localInviteId && isNewMember ? item.newCustPrice : item.price }}
              <text class="price_old m_label0" v-if="showOriginalPrice">{{item.originalprice}}</text>
          </div>
          <div class="buyBtn" v-if="pattern.showBuyBtn">购买</div>
        </div>
      </div>
      <div v-show="!detailData.goodsList.length" class="defaultImg"></div>
    </div>
  </div>
</template>

<script>

import mixins from '../mixins/mixins'
export default {
  name: 'mallItemPerson',
  mixins: [mixins],
  props: {
    allShowVerFlag: {
      type: Boolean,
      default:true
    },
    initFlag: {
      type: Boolean,
      default:true
    },
    list: {
      type: Object,
      default:() => []
    }
  },
  components: {
  },
  data() {
    return {
      nowTime: null,
      detailData: {
        goodsList: []
      },
      content: {},
      pattern: {},
    }
  },
  computed: {
    showOriginalPrice() {
      return true;
    },
    MYK_allMallItemShowSelledCount() {
      return true;
    },
    boxStyle(){
      if(this.initFlag){
        return {
        "margin-left": (this.pattern.margin != undefined ? this.pattern.margin : 10) + 'px',
        "margin-right": (this.pattern.margin != undefined ? this.pattern.margin : 10) + 'px',
        }
      }else{
        return {}
      }
    },
  },
  methods: {
    async init() {
      if(this.initFlag){
        this.nowTime = new Date().getTime()
        this.detailData = await this._filter(this.itemData)
        this.pattern = this.detailData.pattern || {}
        this.content = this.detailData.content || {}
        console.log("mallItemPerson----------this.detailData");
        console.log(this.detailData);
        if(this.detailData.style == 8){
          this.allShowVerFlag = !this.pattern.type || this.pattern.type == 1 
        }
      }else{
        this.detailData.goodsList = this.list
      }
    }
  },
  async mounted() {
    
  }
}
</script>
<style lang="scss" scoped>
.mallItemPerson{
  // padding: 10px;
  // background: #eee;
  .mallTitle{
    height: 22px;
    line-height: 22px;
    margin-bottom: 10px;
    .title{
      font-weight: 900;
      font-size: 16px;
      color: #2E2E2E;
      display: inline-block;
    }
    .moreText{
      font-weight: 400;
      font-size: 12px;
      color: #8F9495;
      float: right;
    }
  }
}

.p-item {
    .m_label1::before {
        font-size: 10px !important;
        content: '¥';
    }
    box-sizing: border-box;
    -webkit-flex: 0 0 50%;
    margin-bottom: 7px;
    flex: 0 0 50%;
    border-radius: 6px;
    // transition: all 0.2s;
    // -webkit-transition: all 0.2s;
    width: 50%;
    display: inline-block;
    overflow: hidden;
    &:nth-child(even) {
        padding-left: 4px;
    }
    &:nth-child(odd) {
        padding-right: 4px;
    }
    &:last-child {
        margin-right: 0;
    }
    .item_logo {
        width: 100%;
        display: block;
        position: relative;
        font-size: 50px;
        background-color: #fff;
        padding-bottom: 5px;
        border-radius: 6px 6px 0 0;
        overflow: hidden;
        .tqj_l {
            font-size: 11px;
            color: #d9bf95;
            background-color: #4a4a4a;
            vertical-align: middle;
            display: inline-block;
            line-height: 21px;
            height: 21px;
            padding: 0 10px;
            border-radius: 25px;
            margin-right: 10px;
            position: absolute;
            bottom: 9px;
            left: 5px;
            z-index: 2;
        }
        .logo_tag{
            position: absolute;
            left: 0;
            top: 0;
            width: 60px;
            height: 60px;
            z-index: 2;
            font-size: 12px;
        }
        img {
          width: 100%;
        }
    }
    .pname {
        box-sizing: border-box;
        padding: 0 10px;
        background-color: #fff;
        font-size: 12px;
        color: #333333;
        padding-bottom: 0;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        position: relative;
        text-align: left;
    }
    .hr {
        background-color: #fff;
        height: 6px;
    }
    .pinfo {
        background: #fff;
        padding: 10px;
        display: flex;
        display: -webkit-flex;
        box-sizing: border-box;
        padding-bottom: 0;
        padding-top: 3px; // height: 50px;
        padding-bottom: 6px;
        position: relative;
        border-radius: 0 0 6px 6px;
        .l_box {
            .price {
                font-size: 13px;
                color: #EB637A;
            }
            .price_old {
                font-size: 11px;
                color: #909090;
                text-decoration: line-through;
                margin-left: 5px;
                &::before {
                    text-decoration: line-through;
                }
            }
            .score_money {
                font-size: 13px;
                &::before {
                    content: '' !important;
                }
            }
            .tag-warp {
                height: 25px;
                display: flex;
                align-items: center;
                padding-bottom: 5px;
                .label_fix {
                    padding-left: 5px;
                }
                .label {
                    margin-top: 3px;
                    font-size: 11px;
                    color: #EB637A;
                    max-height: 25px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    &.integral {
                        color: #909090 !important;
                    }
                }
                .tag {
                    font-size: 10px;
                    padding: 0 4px;
                    margin-right: 4px; // border: 1px solid #EB637A;
                    // border-radius: 2px;
                    position: relative;
                    &::before {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 200%;
                        height: 200%;
                        border: 1px solid #EB637A;
                        border-radius: 4px;
                        transform-origin: 0 0;
                        transform: scale(0.5, 0.5);
                        box-sizing: border-box;
                    }
                }
            }
            .label {
                margin-top: 3px;
                font-size: 11px;
                color: #EB637A;
            }
        }
        .r_box {
            -webkit-flex: 1;
            flex: 1;
            font-size: 11px;
            color: #909090;
            text-align: right;
            padding-top: 3px;
            position: absolute;
            right: 20px;
        }
        .buyBtn{
          width: 24px;
          height: 24px;
          line-height: 24px;
          background-image: linear-gradient(270deg, #698898 0%, #88A5B2 100%);
          border-radius: 50%;
          position: absolute;
          right: 6px;
          bottom: 6px;
          text-align: center;
          .s-iconfont{
            font-size: 16px;
            color: #fff;
          }
        }
    }
}

.p-item_v {
    box-sizing: border-box;
    flex: 0 0 100%;
    -webkit-flex: 0 0 100%;
    display: flex;
    display: -webkit-flex;
    background: #ffffff;
    padding: 10px;
    &:first-child {
      border-radius: 6px 6px 0 0;
    }
    &:last-child {
      border-radius: 0 0 6px 6px;
    }
    // transition: all 0.15s;
    // -webkit-transition: all 0.15s;
    .item_logo {
        width: 90px;
        height: 90px;
        display: block;
        margin-right: 12px;
        font-size: 50px;
        border-radius: 6px;
        overflow: hidden;
        .logo_tag{
            position: absolute;
            left: 0;
            top: 0;
            width: 36px;
            height: 36px;
            z-index: 2;
            font-size: 0;
        }
    }
    .r_box {
        position: relative;
        flex: 1;
        -webkit-flex: 1; // transition: all .5s;
        // -webkit-transition: all .5s;
        display: flex;
        flex-direction: column;
        .price{
          font-size: 14px;
          font-weight: 500;
          color: #eb637a;
        }
        .m_label1::before{
          font-size: 10px!important;
          content: "¥";
        }
        .pname {
            background-color: #fff;
            font-size: 14px;
            font-weight: 500;
            color: #333333;
            padding-top: 6px;
            padding-bottom: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            position: relative;
            margin-bottom: 4px;
        }
        .label {
            font-size: 11px;
            color: #EE6E7F;
            margin-top: 2px;
            height: 23px;
            flex: 1;
            .tqj_l {
                font-size: 11px;
                color: #d9bf95;
                background-color: #4a4a4a;
                display: inline-block;
                line-height: 18px;
                height: 18px;
                padding: 0 10px;
                border-radius: 25px;
                margin-right: 10px;
            }
            +.bottom_info {
                margin-top: 8px !important;
            }
        }
        .tag-warp {
            height: 25x;
            display: flex;
            align-items: center;
            .label {
                font-size: 11px;
                color: #EE6E7F;
                margin-top: 2px;
                white-space: nowrap;
                &.integral {
                    color: #909090;
                }
                .tqj_l {
                    font-size: 11px;
                    color: #d9bf95;
                    background-color: #4a4a4a;
                    display: inline-block;
                    line-height: 18px;
                    height: 18px;
                    padding: 0 10px;
                    border-radius: 25px;
                    margin-right: 10px;
                }
                +.bottom_info {
                    margin-top: 8px !important;
                }
            }
            .tag {
                font-size: 10px;
                padding: 0 4px;
                margin-right: 5px; // border: 1px solid #EB637A;
                // border-radius: 2px;
                position: relative;
                &::before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 200%;
                    height: 200%;
                    border: 1px solid #EB637A;
                    border-radius: 4px;
                    transform-origin: 0 0;
                    transform: scale(0.5, 0.5);
                    box-sizing: border-box;
                }
            }
        }
        .lit_title {
            font-size: 11px;
            color: #909090;
            line-height: 15px;
            height: 15px;
            +.label {
                margin-top: 2px !important;
                +.bottom_info {
                    margin-top: 2px !important;
                }
            }
        }
        .bottom_info {
            margin-top: 25px;
            .item_box {
                display: inline-block;
                width: 50%;
                font-size: 11px;
                color: #909090;
                .old {
                    text-decoration: line-through;
                    margin-left: 5px;
                }
                .price {
                    font-size: 14px;
                    color: #EB637A;
                    font-weight: bold;
                }
                .margin-r {
                    margin-right: 5px;
                }
            }
        }
        .buyBtn{
          width: 52px;
          height: 22px;
          line-height: 22px;
          background-image: linear-gradient(270deg, #698898 0%, #88A5B2 100%);
          border-radius: 12px;
          position: absolute;
          right: 5px;
          bottom: 3px;
          font-weight: 900;
          font-size: 14px;
          color: #FFFFFF;
          text-align: center;
        }
    }
}
#goodsClassBox .mallItemPerson{
  padding: 0;
  background: #fff;
}
#goodsClassBox .p-item_v{
    padding: 0;
    margin-bottom: 15px;
    .price {
        display: block;
        font-size: 14px;
        color: #EB637A;
        font-weight: bold;
    }
    .m_label1::before {
        font-size: 10px !important;
        content: '¥';
    }
    .pname{
        font-size: 12px;
        padding-top: 5px;
        font-size: 13px;
        font-weight: 600;
        margin-bottom: 5px;
    }
    .label{
      height: 0;
    }
    .pname,
    .lit_title{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 135px;

      }
    .lit_title{
      color: #ababab;
    }
    .bottom_info .item_box.right{
        display: none;
    }
    .item_logo{
        width: 68px;
        height: 68px;
        img{
          border-radius: 3px;
        }
    }
    .r_box{
      width: 135px;
    }
}
.defaultImg{
    width: 100%;
    height: 0;
    padding-top: 72%;
    background-image: url("../image/mallItemPerson.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

</style>

